module.exports = __webpack_public_path__ + "img/map.8a431155.svg";